import posthog from 'posthog-js'
import {
  appendCampaignParams,
  readCampaignParams,
} from '@/features/tracking/analytics/campaign-params'

type AuthAction = 'sign-in' | 'sign-up'

const PRIMARY_ORIGIN_PROD = 'https://wwjdfilm.com'
const PRIMARY_ORIGIN_DEV = 'http://localhost:3000'

export function getPrimaryAuthOrigin(): string {
  return process.env.NODE_ENV === 'development' ? PRIMARY_ORIGIN_DEV : PRIMARY_ORIGIN_PROD
}

export function buildPrimaryAuthUrl(params: {
  action: AuthAction
  redirectUrl: string
  signupBrandId?: 'christspiracy' | 'wwjd'
}): string {
  const origin = getPrimaryAuthOrigin()
  const path = params.action === 'sign-in' ? '/sign-in' : '/sign-up'

  const url = new URL(path, origin)
  url.searchParams.set('redirect_url', params.redirectUrl)

  if (params.action === 'sign-up' && params.signupBrandId) {
    url.searchParams.set('signup_brand_id', params.signupBrandId)
  }

  if (typeof window !== 'undefined') {
    appendCampaignParams(
      url,
      readCampaignParams(window.location.search, (key) => posthog.getSessionProperty(key)),
    )
  }

  return url.toString()
}
